import { NavLink } from 'react-router-dom';
import { ButtonText } from 'components/UI/Brand/text';
import clsx from 'clsx';
import { track } from 'utils/analytics';
import translate from 'translate';
import { Button } from 'components/UI/new';
import { useLaunchSeawarePlatformContext } from 'contexts/LaunchSeawarePlatformContext';
import { isShowingSeawareSearch } from 'utils/search/isShowingSeawareSearch';
import useSeawareMessageHidden from 'components/Search/SeawareBranch/useSeawareMessageHidden';
import { useCallback } from 'react';
import styles from './styles.module.scss';

const trackLearn = () => track('Click learn');
// const trackGetCertified = () => track('Click get certified');
const trackResources = () => track('Click resources');
const trackAgencyArea = () => track('Click Agenturbereic German');

interface INavItemsLeftProps {
  setLearnButtonActive: (value: boolean) => void;
  setShowLearnNavigation: (value: boolean) => void;
}

const NavItemsLeft = ({
  setShowLearnNavigation,
  setLearnButtonActive,
}: INavItemsLeftProps) => {
  const { showLaunchSeawarePlatformModal } = useLaunchSeawarePlatformContext();
  const showSeawareBranch = isShowingSeawareSearch();
  const { isSeawareMessageHidden } = useSeawareMessageHidden();

  const handleLaunchPlatform = useCallback(() => {
    if (isSeawareMessageHidden) {
      window.open(process.env.REACT_APP_SEAWARE_TOUCH_ENDPOINT, '_blank');
    } else {
      showLaunchSeawarePlatformModal();
    }
  }, [isSeawareMessageHidden, showLaunchSeawarePlatformModal]);

  return (
    <>
      <ul
        className={styles.list}
        onMouseLeave={() => setLearnButtonActive(false)}
        onMouseEnter={() => {
          setShowLearnNavigation(true);
          setLearnButtonActive(true);
        }}
      >
        {
          <li>
            <NavLink
              to="/learn"
              end
              className={({ isActive }) =>
                clsx(styles.link, {
                  [styles.linkActive]: isActive,
                })
              }
              onClick={() => {
                trackLearn();
                setShowLearnNavigation(false);
              }}
            >
              <ButtonText>{translate('Navbar_Learn')}</ButtonText>
            </NavLink>
          </li>
        }
        {/* {canRegionShowTraining() && (
      {canRegionShowTraining() && (
        <li>
          <NavLink
            to="/training"
            end
            className={({ isActive }) =>
              clsx(styles.link, {
                [styles.linkActive]: isActive,
              })
            }
            onClick={() => {
              trackGetCertified();
              setShowLearnNavigation(false);
            }}
            onMouseEnter={() => setShowLearnNavigation(false)}
          >
            <ButtonText>{translate('Navbar_Training')}</ButtonText>
          </NavLink>
        </li>
      )} */}
        <li>
          <NavLink
            to="hx-training"
            end
            className={({ isActive }) =>
              clsx(styles.link, {
                [styles.linkActive]: isActive,
              })
            }
            onClick={() => {
              trackAgencyArea();
              setShowLearnNavigation(false);
            }}
          >
            <div className={styles.routeWithBadge}>
              <ButtonText>{translate('Navbar_Training')}</ButtonText>
              {showSeawareBranch && (
                <div className={styles.badge}>
                  {translate('General_New').toUpperCase()}
                </div>
              )}
            </div>
          </NavLink>
        </li>

        <li>
          <NavLink
            to="/marketing"
            end
            className={({ isActive }) =>
              clsx(styles.link, {
                [styles.linkActive]: isActive,
              })
            }
            onClick={() => {
              trackResources();
              setShowLearnNavigation(false);
            }}
            onMouseEnter={() => setShowLearnNavigation(false)}
          >
            <ButtonText>{translate('Navbar_Marketing')}</ButtonText>
          </NavLink>
        </li>

        <li>
          <NavLink
            to="/learn/articleContainer/48WIPkoHRvQi0Fo6vhzdGa"
            end
            className={({ isActive }) =>
              clsx(styles.link, {
                [styles.linkActive]: isActive,
              })
            }
            onClick={() => {
              trackAgencyArea();
              setShowLearnNavigation(false);
            }}
          >
            <ButtonText>{translate('Navbar_AgencyArea')}</ButtonText>
          </NavLink>
        </li>
        {showSeawareBranch && (
          <li>
            <Button
              variant="secondary"
              size="small"
              icon="newTab"
              onClick={handleLaunchPlatform}
            >
              {translate('Navbar_SeawareLink')}
            </Button>
          </li>
        )}
      </ul>
    </>
  );
};

export default NavItemsLeft;
